var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.7002 4H7.3C5.1 4 4 5.1 4 7.3L4.00065 22.7C4.00065 24.9 5.10023 26 7.30023 26H22.7002C24.9002 26 26.0002 24.9 26.0002 22.7V7.3C26.0002 5.1 24.9002 4 22.7002 4ZM11.3336 21.4167H8.58356V11.3333H11.3336V21.4167ZM9.95856 10.171C9.07306 10.171 8.3544 9.44684 8.3544 8.55401C8.3544 7.66117 9.07306 6.937 9.95856 6.937C10.8441 6.937 11.5627 7.66117 11.5627 8.55401C11.5627 9.44684 10.845 10.171 9.95856 10.171ZM22.3336 21.4167H19.5836V16.2797C19.5836 13.1924 15.9169 13.4261 15.9169 16.2797V21.4167H13.1669V11.3333H15.9169V12.9512C17.1966 10.5808 22.3336 10.4057 22.3336 15.221V21.4167Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIn);
export default __webpack_public_path__ + "static/media/in.3da59599c31599ec2b46bf6ae91d5891.svg";
export { ForwardRef as ReactComponent };